// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
export const environment = {
    production: false,
    accessKey: '',
    portalAccessKey: '',
    azureaccessKey: '',
    azureportalAccessKey: '',
    PracticeID: '',
    UserPracticeId: '',
    PatientImage: '',
    datTableFlag: false,
    isAuthorizeuser: false,
    usertype: 'patientportal',
    isAzure: false,
    appSetting: {
        'azureidentityserver': '',
        'azurePatientPortalUrl': '',
        'azureapiUrl': '',
        'identityserver': '',
        'clientid': '',
        'secretkey': '',
        'portalclientid': '',
        'portalsecretkey': '',
        'hashcode': '',
        'apiUrl': '',
        'patientPicturesFolderPath': '',
        'defaultImagePath': '',
        'defaultPicturesFolderPath': require('../assets/img/login-logo.png'),
        'PracticeHeader': '',
        'PracticeShortName': '',
        'teleHealthAccess': '',
        'instaPractURL': '',
        'connectmmdURL': '',
        'requestFrom': '',
        'formId': 0,
        'baseUrI': '',
        'androidAppStore': '',
        'iphoneAppStore': '',
        'isProd': true,
        'prodType': '',
        'logoutURL': ''

    }


};
